// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const InternalDiscoveryRunStatusSchema = z.enum(['IDLE','ENROLLING','COLLECTING','IMPORTING','NORMALIZING','ANALYZING','COMPLETED','FAILED','STOPPED'] as const);

export type InternalDiscoveryRunStatusType = `${z.infer<typeof InternalDiscoveryRunStatusSchema>}`

export default InternalDiscoveryRunStatusSchema;
